import axios from "axios";
import API_URL from '../../components/config';

export const logout = async (navigate, setIsLoggedIn) => {
  try {
    // Optional: Call backend logout endpoint if it exists
    await axios.post(`${API_URL}/logout`, {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`
      }
    });
    
    localStorage.removeItem("adminToken");
    
    // Update the state immediately
    if (setIsLoggedIn) {
      setIsLoggedIn(false);
    }
    
    // Dispatch custom event to update all components
    window.dispatchEvent(new CustomEvent('authStatusChanged'));
    
    navigate("/");
    console.log("🚪 Successfully logged out");
  } catch (error) {
    console.error("Logout error:", error);
    // Even if backend logout fails, clear local token and redirect
    localStorage.removeItem("adminToken");
    
    // Update the state immediately
    if (setIsLoggedIn) {
      setIsLoggedIn(false);
    }
    
    // Dispatch custom event to update all components
    window.dispatchEvent(new CustomEvent('authStatusChanged'));
    
    navigate("/");
  }
};

// Add a helper function for login (you should call this after successful login)
export const setAuthToken = (token) => {
  localStorage.setItem("adminToken", token);
  // Dispatch custom event to update all components
  window.dispatchEvent(new CustomEvent('authStatusChanged'));
};